import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import styles from './Logo.module.css'

export default function Logo() {
    return (
    <div className={styles.container}>
        <div className={styles.layout}>
            <div className={styles.wrapper}> 
                <h1 className="title">
                    <span className="underline">
                        Хамтран ажилласан байгууллагууд
                    </span>
                </h1>
                <div className={styles.grid}>
                    <div className={styles.logo}>
                        <a href="https://pecb.com/" target="_blank" rel="noreferrer">
                            <StaticImage src="../../../images/logo/pecb.png" alt="pecb" width={100}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="https://www.pmi.org/" target="_blank" rel="noreferrer">
                            <StaticImage src="../../../images/logo/pmi.png" alt="pmi" width={100}/>
                        </a>
                    </div>
               
                    <div className={styles.logo}>
                        <a href="https://www.mn.undp.org/content/mongolia/en/home/projects/nationally-appropriate-mitigation-actions--nama-.html" target="_blank" rel="noreferrer">
                            <StaticImage src="../../../images/logo/undp.png" alt="undp mongolia" width={100}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="https://ecfund.mn/" target="_blank" rel="noreferrer">
                        <StaticImage src="https://cdn.greensoft.mn/uploads/site/543/site_config/logo/b60c781906a3cd2cf8ad6d99f2f214f456f5ef8f.png" alt="baigali orchin uur amisgaliin san"/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="https://erc.gov.mn/web/mn/" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/zohitsuulah.svg" alt=" erchim huchnii zohitsuulah horoo" width={100}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="https://mcud.gov.mn/" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/barilga.jpg" alt="barilga hot baiguulaltiin yam" width={100}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="https://www.pwc.com/mn/mn.html" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/pwc_mongolia.png" alt="pwc" height={50}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="https://orchlon.mn/" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/gutal.png" alt="gutal" width={75}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="https://www.erdenetmc.mn/" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/erdenet.svg" alt="erdenet" width={100}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="http://gutalco.mn/" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/orchlon.png" alt="orchlon" width={100}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="http://seruun.mn/" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/seruun.png" alt="seruun" width={100}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="Мөнхийн баян гал ХХК" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/cucc.png" alt="munhiin bayan gal" width={50}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="Киловатт цаг ХХК" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/kw tsag.png" alt="kw tsag" width={50}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="http://observeconsulting.com/" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/observe.jpg" alt="observe" width={85}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="https://new.abb.com/mn" target="_blank" rel="noreferrer">
                        <StaticImage src="../../../images/logo/abb.png" alt="abb" width={85}/>
                        </a>
                    </div>
                    <div className={styles.logo}>
                        <a href="http://shugam.mn/" target="_blank" rel="noreferrer">
                        <StaticImage src="https://cdn.greensoft.mn/uploads/site/454/site_config/logo/fb1df099e3cd83b9dd57c2bad4702e1460d00b94.png" alt="shugam" width={100}/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}
